<div class="calendar-schedule flex flex--column rounded-large overflow-hidden ps-small-t">
  <div class="calendar-schedule__calendar flex-1">
    @if (openWithParams()) {
      <fin-price-calendar
        [noSnippet]="true"
        [openWithParams$]="openWithParams$"
        [displayMonths]="1"
        [embedded]="true"
        [showAddReturn]="true"
        [fetchPricesInSSR]="false"
        [knownPricesAvailable]="pricesAvailable()"
        [ctaLabel]="'timetable.panel.bookFlights' | finLocalization"
        [noPricesDayTemplate]="flightCountDayTemplate"
        (ctaClicked)="onBookFlights($event)"
        (travelDatesChanged)="onTravelDatesChanged($event)"
        (addReturnClicked)="onAddReturn()"
        (visibleRangeChange)="onVisibleRangeChange($event)"
      />
    }
  </div>

  <div class="calendar-schedule__timetable flex-1 ps-xsmall-t ps-large-x">
    <fin-timetable-schedule-panel
      [departureBounds]="departureBounds()"
      [departureDate]="travelDates()?.departureDate"
      [departureLoading]="departureLoading()"
      [departureOriginCode]="hasSelectedDate() ? origin() : undefined"
      [departureDestinationCode]="hasSelectedDate() ? destination() : undefined"
      [returnBounds]="returnBounds()"
      [returnDate]="travelDates()?.returnDate"
      [returnLoading]="returnLoading()"
      [returnOriginCode]="hasReturnDate() ? destination() : undefined"
      [returnDestinationCode]="hasReturnDate() ? origin() : undefined"
      [showReturnTab]="showReturnTab()"
      [returnTabActive]="hasReturnDate()"
    />
  </div>
</div>

<ng-template #flightCountDayTemplate let-dayValue="dayValue">
  @let noOfFlights = flightCounts()[dayValue.id];
  <div class="flight-count" [attr.data-testid]="'calendar-flights-' + dayValue.id">
    <div
      class="flight-count__value flex flex--center flex--middle"
      [class.flight-count__value--hidden]="!(noOfFlights > 0)"
      [attr.aria-hidden]="noOfFlights > 0 ? null : 'true'"
    >
      <span class="light-type font-body-medium">{{ noOfFlights ?? 0 }}</span>
      <fcom-icon [name]="SvgLibraryIcon.AIRCRAFT_TILTED" class="icon-small" />
    </div>
    <div
      class="day-border fill absolute ms-xxsmall-b"
      [class.signal-success-notification-bg]="noOfFlights > 0"
      [class.surface-disabled-bg]="noOfFlights === 0"
      [class.surface-secondary]="noOfFlights === undefined"
    ></div>
  </div>
</ng-template>
